import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { useIsTruncated } from '@/hooks/useIsTruncated';
import { cn } from '@/lib/utils';

interface TruncatedTextProps {
  text: string;
  className?: string;
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** `large` wraps the tooltip at 240px instead of letting it run on one line. */
  size?: 'default' | 'large' | 'auto';
}

/**
 * Renders text on a single line and only shows a tooltip when it actually overflows.
 */
export const TruncatedText = ({
  text,
  className,
  align,
  side = 'bottom',
  size = 'auto',
}: TruncatedTextProps) => {
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>('horizontal', [text]);

  return (
    <InfoTooltip content={isTruncated ? text : undefined} side={side} align={align} size={size}>
      <span ref={ref} className={cn('truncate', className)}>
        {text}
      </span>
    </InfoTooltip>
  );
};
